import { combineTokens, makeSelectors } from '@utils/css';

const transitionDurationMs = {
  enter: 150,
  exit: 100
};
const dropdownTokens = combineTokens("--dropdown", {
  zIndex: "100011"
});
const dropdownWrapper = "dibdozyzxq";
const dropdown = "dibdy65jj4";
const arrow = "diba1k0unby";
const dropdownBackdrop = "dibdvaukqm";
const dropdownSelectors = makeSelectors({
  content: dropdown,
  backdrop: dropdownBackdrop
});

export { arrow, dropdown, dropdownBackdrop, dropdownSelectors, dropdownTokens, dropdownWrapper, transitionDurationMs };
import "./dropdown.style.linaria.module.css";
//# sourceMappingURL=dropdown.style.js.map
